import api from '@/services/api/config';

const path = 'v1/prozesskontrollkarte/fertigungsauftrag';

export default {
  getById: (id) => api.get(`${path}/${id}`),
  get: ({
    page, size, sort = null, desc = false, status = null, notStatus = null, suche = null, sucheReason = null, werkzeug = null, teilegruppe = null, hasError = null, hasFarbpruefung = null, versendet = null, dokumenteKontrolliert = null,
  }) => api.get(path, {
    params: {
      page, size, sort, desc, suche, status, not_status: notStatus, suche_reason: sucheReason, werkzeug, teilegruppe, has_error: hasError, has_farbpruefung: hasFarbpruefung, versendet, dokumente_kontrolliert: dokumenteKontrolliert,
    },
  }),
  getAnzahl: ({
    status = null, notStatus = null, suche = null, sucheReason = null, werkzeug = null, teilegruppe = null, hasError = null, hasFarbpruefung = null, versendet = null, dokumenteKontrolliert = null,
  }) => api.get(`${path}/anzahl`, {
    params: {
      suche, sucheReason, status, not_status: notStatus, werkzeug, teilegruppe, has_error: hasError, has_farbpruefung: hasFarbpruefung, versendet, dokumente_kontrolliert: dokumenteKontrolliert,
    },
  }),
  getFromAuftrag: (auftrag, position) => api.get(`${path}/${auftrag}/${position}`),
  create: (prozesskontrollkarte) => api.post(path, prozesskontrollkarte),
  update: (id, prozesskontrollkarte) => api.put(`${path}/${id}`, prozesskontrollkarte),
  zumAbruestenGeben: (id) => api.patch(`${path}/${id}/zum-abruesten-geben`),
  abschliessen: (id, data) => api.patch(`${path}/${id}/abschliessen`, data),
  reopen: (id) => api.patch(`${path}/${id}/reopen`),
  versandt: (id) => api.patch(`${path}/${id}/versandt`),
  patch: (id, changes) => api.patch(`${path}/${id}`, changes),
  export: () => api.get(`${path}/export`),
  getDruckmessungen: (id) => api.get(`${path}/${id}/druckmessung`),
  saveDruckmessungen: (id, messungen) => api.post(`${path}/${id}/druckmessung`, { messungen }),
  getSpcAuswertung: (id) => api.get(`${path}/${id}/spc-auswertung`),
  addDocument: (id, refId, formData) => api.post(`${path}/${id}/dokument/${refId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  setDokumenteKontrolliert: (id) => api.patch(`${path}/${id}/dokumente-kontrolliert`),
};
